import { isFessh } from "@/utils/is-fessh";
import { useTranslation } from "react-i18next";

export function Logo() {
  const { t } = useTranslation();

  if (isFessh) {
    return (
      <div className="flex items-center gap-x-1 px-3">
        {/* <div className="h-8 w-9">
          <img
            alt="Fessh"
            src="https://app.fessh.com/static/media/logo.e955e53a.png"
            className="h-8 w-auto"
          />
        </div> */}
        <span className="text-lg font-semibold">{t("brand.fessh")}</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-x-1 px-3">
      {/* <div className="h-8 w-9">
        <img
          alt="CongressWorks"
          src="https://app.asszisztencia.hu/static/media/logo-cw.0b9283de.png"
          className="h-8 w-auto rounded"
        />
      </div> */}
      <span className="text-lg font-semibold">{t("brand.congressWorks")}</span>
    </div>
  );
}
